import EntityOverviewPage from 'Components/Organisms/Entity/EntityOverviewPage/EntityOverviewPage';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from 'Services/Route/Route.types';

const VacancyOverviewPage = () => {
    return (
        <PageTemplate>
            <Helmet>
                <title>{ROUTES.VACANCIES.title}</title>
            </Helmet>

            <EntityOverviewPage
                entity_name='vacancy'
            />
        </PageTemplate>
    )
}

export default VacancyOverviewPage;